<script lang="ts">
  interface HealthData {
    database: {
      status: string;
      sizeMb: string;
      totalOrders: number;
      totalProducts: number;
    };
    redis: {
      status: string;
      memoryUsed: string | null;
    };
    uptime: number;
  }

  let { healthData }: { healthData: HealthData | null } = $props();

  function statusBadge(status: string) {
    if (status === 'connected') return 'badge-success';
    if (status === 'disconnected') return 'badge-error';
    return 'badge-warning';
  }

  function formatUptime(seconds: number) {
    const days = Math.floor(seconds / 86400);
    const hours = Math.floor((seconds % 86400) / 3600);
    const mins = Math.floor((seconds % 3600) / 60);
    return `${days}d ${hours}h ${mins}m`;
  }
</script>

<div class="p-6 bg-base-100 border border-base-300 rounded-2xl space-y-4">
  <div class="flex items-center justify-between">
    <div>
      <h3 class="text-sm font-bold uppercase tracking-wider text-base-content/70">System Health Telemetry</h3>
      <p class="text-xs text-base-content/50">Live infrastructure diagnostics & storage metrics</p>
    </div>
    {#if healthData}
      <span class="flex h-2 w-2 rounded-full bg-success animate-ping"></span>
    {:else}
      <span class="flex h-2 w-2 rounded-full bg-base-300"></span>
    {/if}
  </div>

  {#if healthData}
    <div class="grid grid-cols-2 gap-4">
      <div class="bg-base-200/50 border border-base-300 rounded-xl p-3 space-y-2">
        <div class="flex items-center justify-between">
          <span class="text-[10px] font-bold uppercase tracking-wider text-base-content/50">Postgres</span>
          <span class="badge {statusBadge(healthData.database.status)} badge-xs font-bold"></span>
        </div>
        <div class="text-xs space-y-1">
          <div class="flex justify-between"><span class="text-base-content/60">Size</span><span class="font-bold">{healthData.database.sizeMb} MB</span></div>
          <div class="flex justify-between"><span class="text-base-content/60">Orders</span><span class="font-bold">{healthData.database.totalOrders}</span></div>
          <div class="flex justify-between"><span class="text-base-content/60">Products</span><span class="font-bold">{healthData.database.totalProducts}</span></div>
        </div>
      </div>

      <div class="bg-base-200/50 border border-base-300 rounded-xl p-3 space-y-2">
        <div class="flex items-center justify-between">
          <span class="text-[10px] font-bold uppercase tracking-wider text-base-content/50">Redis</span>
          <span class="badge {statusBadge(healthData.redis.status)} badge-xs font-bold"></span>
        </div>
        <div class="text-xs space-y-1">
          <div class="flex justify-between"><span class="text-base-content/60">Memory</span><span class="font-bold">{healthData.redis.memoryUsed || 'N/A'}</span></div>
          <div class="flex justify-between"><span class="text-base-content/60">Uptime</span><span class="font-bold">{formatUptime(healthData.uptime)}</span></div>
        </div>
      </div>
    </div>
  {:else}
    <div class="py-8 text-center text-xs text-base-content/40 uppercase tracking-widest border border-dashed border-base-300 rounded-xl">
      Loading telemetry...
    </div>
  {/if}
</div>
